/* ============================================
   PETIKIDS CHARM CATEGORY GRID — ATC par carte
   ============================================ */
(function () {
  'use strict';

  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return [...(c || document).querySelectorAll(s)]; }

  function showToast(message, variant) {
    const toast = qs('#ccg-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.remove('ccg-toast--error', 'ccg-toast--success');
    toast.classList.add('ccg-toast--visible', variant === 'error' ? 'ccg-toast--error' : 'ccg-toast--success');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('ccg-toast--visible'), 2500);
  }

  function getCartRenderer() {
    // Shrine Pro uses either <cart-drawer> OR <cart-notification> depending on theme settings.
    // Both expose a native renderContents(parsedState) method that handles injection + focus trap + opening.
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getSectionsToRequest(renderer) {
    if (!renderer) return ['cart-icon-bubble'];
    if (typeof renderer.getSectionsToRender === 'function') {
      return renderer.getSectionsToRender().map(s => s.section || s.id);
    }
    // Fallbacks by tag
    if (renderer.tagName === 'CART-NOTIFICATION') {
      return ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async function addCharm(card, grid) {
    const variantId = grid.dataset.charmVariantId;
    if (!variantId) {
      showToast('Configuration manquante : variant charm', 'error');
      return;
    }
    const btn = card.querySelector('.ccg-card__atc');
    if (btn && btn.disabled) return;

    const charm = {
      id: card.dataset.charmId,
      name: card.dataset.charmName,
      sku: card.dataset.charmSku,
      image: card.dataset.charmImage,
    };

    if (btn) {
      btn.disabled = true;
      btn.dataset._label = btn.textContent;
      btn.textContent = 'Ajout...';
    }

    const properties = { 'Charm': charm.name };
    if (charm.sku) properties['_SKU'] = charm.sku;
    if (charm.image) properties['_charm_image'] = charm.image;

    const renderer = getCartRenderer();
    const sections = getSectionsToRequest(renderer);

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1, properties }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.description || data.message || 'Erreur ajout panier');

      // Hand off to the theme's native renderer — it knows its own DOM structure
      // and will open the drawer/notification with correct focus trap.
      if (renderer && typeof renderer.renderContents === 'function') {
        // Cart is no longer empty after ATC — strip the stale `is-empty` class that
        // Shrine Pro renders at page load. Without this, open() picks the empty-cart
        // focus container (which no longer exists post-render) and trapFocus crashes.
        renderer.classList.remove('is-empty');
        renderer.renderContents(data);
      }

      showToast(charm.name + ' ajouté au panier', 'success');
      document.dispatchEvent(new CustomEvent('ccg:added', { detail: { charm, variantId } }));
    } catch (err) {
      console.error('[CCG] ATC error', err);
      showToast(err.message || 'Erreur ajout panier', 'error');
    } finally {
      if (btn) {
        btn.disabled = card.classList.contains('ccg-card--oos');
        btn.textContent = btn.dataset._label || 'Ajouter au panier';
      }
    }
  }

  function init(section) {
    const grid = section.querySelector('.charm-category__grid');
    if (!grid) return;

    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="add-to-cart"]');
      if (!btn) return;
      e.preventDefault();
      const card = btn.closest('.ccg-card');
      if (!card || card.classList.contains('ccg-card--oos')) return;
      addCharm(card, grid);
    });
  }

  function boot() {
    qsa('.charm-category-section, .charm-category').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (!e.target) return;
    const section = e.target.querySelector('.charm-category') || (e.target.classList && e.target.classList.contains('charm-category') ? e.target : null);
    if (section) init(section);
  });
})();
